<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="公众号">
              <a-select
                show-search
                placeholder="请选择渠道"
                option-filter-prop="children"
                style="width: 200px;margin-left: auto"
                v-model="queryParam.appId"
                id="aa"
              >
                <a-select-option
                  v-for="item in wechatApp"
                  :key="item.appId"
                  :value="item.appId"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="名字">
              <j-input
                placeholder="输入名字模糊查询"
                v-model="queryParam.name"
              ></j-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQueryAfter" icon="search"
                >查询</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAddAfter" type="primary" icon="plus"
        >新增</a-button
      >
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="status" slot-scope="text, record">
          {{ record.status == 1 ? '正常' : '禁用' }}
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <EventCommandModal ref="modalForm" @ok="modalFormOk"></EventCommandModal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JInput from '@/components/jeecg/JInput';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import EventCommandModal from './EventCommandModal';
import { getAction } from '@api/manage';

export default {
  name: 'EventCommandIndex',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JInput,
    EventCommandModal
  },
  data() {
    return {
      description: 'WECHAT_APP管理页面',
      queryParam: {},
      wechatApp: [],
      // 表头
      columns: [
        {
          title: '指令名字',
          align: 'center',
          dataIndex: 'name'
        },
        {
          title: '事件指令',
          align: 'center',
          dataIndex: 'eventCommand'
        },
        {
          title: '处理类型',
          align: 'center',
          dataIndex: 'handleType'
        },
        {
          title: '处理内容',
          align: 'center',
          dataIndex: 'handleContent'
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_WECHAT + '/',
        delete: process.env.VUE_APP_CMS_WECHAT + '/eventCommand/remove'
      },
      dictOptions: {}
    };
  },
  created() {
    this.getWechatApp();
  },
  methods: {
    initDictConfig() {},
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: '1,2'
      }).then(res => {
        if (res.success) {
          this.wechatApp = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    searchQueryAfter() {
      if (!this.queryParam.appId) {
        this.$message.warn('请选择公众号');
        return;
      }
      this.searchQuery();
    },
    handleAddAfter() {
      if (!this.queryParam.appId) {
        this.$message.warn('请选择公众号');
        return;
      }
      this.$refs.modalForm.appId = this.queryParam.appId;
      this.handleAdd();
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
